import client from "./client";

const getCountries = () => client.get("/subsidiary/dashboard/service/countries");
const getBusinessSize = () => client.get("/subsidiary/dashboard/service/business-sizes");
const getBusinessCategories = () => client.get("/subsidiary/dashboard/business/categories");
export default { getCountries, getBusinessSize, getBusinessCategories };
